import { render, staticRenderFns } from "./RequirementFilter.vue?vue&type=template&id=568b60f9&scoped=true"
import script from "./RequirementFilter.vue?vue&type=script&lang=js"
export * from "./RequirementFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b60f9",
  null
  
)

export default component.exports